import React, { FC, ReactNode } from "react";
import { Popconfirm } from "antd";
import StatusIcon from "../statusIcon/StatusIcon";
import "./ConfirmationPopover.scss";

export type ConfirmationPopoverProps = {
  title: string;
  description?: string;
  onConfirm: () => void;
  okText?: string;
  cancelText?: string;
  type?: "warning" | "danger" | "info";
  showIcon?: boolean;
  children: ReactNode;
};

const ConfirmationPopover: FC<ConfirmationPopoverProps> = ({
  title,
  description,
  onConfirm,
  okText = "Yes",
  cancelText = "No",
  type = "warning",
  showIcon = true,
  children,
}) => {
  return (
    <Popconfirm
      title={title}
      description={description}
      onConfirm={onConfirm}
      okText={okText}
      cancelText={cancelText}
      icon={showIcon ? <StatusIcon type={type} /> : null}
      overlayClassName="confirmation-popover"
    >
      {children}
    </Popconfirm>
  );
};

export default ConfirmationPopover;
